

/*
 * Date: 2025
 * Description: Sidebar for part catalogs filtering
 * Author: Philippe Leroux @ skitsc
 */

//Modules
import { ChangeEvent, ReactElement, useContext } from "react";
import { Box, Select, Typography , MenuItem, TextField, IconButton, SelectChangeEvent , InputAdornment} from "@mui/material";

//Icons
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import WidgetsIcon from '@mui/icons-material/Widgets';
//Interfaces
import { i_makes, i_models } from "../../interfaces/items.interface";
import { i_side_bar_props } from "../../interfaces/display.interfaces";
import SideBarBottom from "./side.bar.bottom";
import MidBar from "./mid.bar";
import { ThemeContext } from "../../context/context";

const SideBar = ( props : i_side_bar_props) : ReactElement => {
    const handleChange = (event : SelectChangeEvent) => {
        const { name , value } = event.target
        props.setFilter({...props.filter, [name] : value , search : 'initial' , page : 1})
    }
    const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        props.setSku(value.replace(/\s+/g, '')); 
    };
    const { mode } = useContext(ThemeContext)
    return(
            <Box sx={{ paddingLeft : 1 , paddingRight : 1, width : '100%' , height : '100%' , backgroundColor: mode === 'Light' ? "white" : "#222", display: 'flex', flexDirection: 'column'}}>
                <Box sx={{ display : 'flex'}}>
                    <IconButton onClick={() => props.setHide(true)} sx={{ marginRight : 2}}><WidgetsIcon/></IconButton>
                    <Typography sx={{ fontWeight : 800, textDecoration : 'underline' , alignSelf : 'center'}}>Search a car</Typography>
                    <IconButton sx={{ marginLeft : 'auto'}} onClick={() => props.handleReset()}>
                        <RestartAltIcon />
                    </IconButton>
                </Box>
                <Box>
                    <Typography>Select a make</Typography>
                    <Select size={'small'} value={props.filter.make_id === '' ? 'default' : props.filter.make_id} name='make_id' onChange={handleChange} sx={{ width : '100%'}}>
                        <MenuItem value="default">Select a make</MenuItem>
                        {props.makes.map((make : i_makes, index : number) => (
                            <MenuItem key={index} value={make._id}>{make.name}</MenuItem>
                        ))}
                    </Select>
                </Box>
                <Box sx={{ marginTop : '2vh'}}>
                    <Typography>Select a model</Typography>
                    <Select size={'small'} disabled={props.filter.make_id === '' ? true : false} value={props.filter.model_id === '' ? 'default' : props.filter.model_id} name='model_id' onChange={handleChange}sx={{ width : '100%'}}>
                    <MenuItem value="default">Select a model</MenuItem>
                        {props.models.map((model : i_models, index : number) => (
                            <MenuItem key={index} value={model._id}>{model.name}</MenuItem>
                        ))}
                    </Select>
                </Box>
                <Box sx={{ marginTop : '2vh'}}>
                    <Typography>Select a Year</Typography>
                    <Select size={'small'} disabled={props.years.length === 0 ? true : false} value={props.filter.year === '' ? 'default' : props.filter.year}  name='year' onChange={handleChange} sx={{ width : '100%'}}>
                        <MenuItem value="default">Select a year</MenuItem>
                        {props.years.map((year : number, index : number) => (
                            <MenuItem key={index} value={year}>{year.toString()}</MenuItem>
                        ))}
                    </Select>
                </Box>
                <Box sx={{ marginTop : '2vh'}}>
                    <Typography>Search by SKU</Typography>
                    <TextField size="small" sx={{ width: '100%' }} value={props.sku} onChange={handleInput} name={'sku'} placeholder="Enter SKU..." slotProps={{  input : { endAdornment: ( <InputAdornment position="end"> <IconButton onClick={() => props.skuCallback()}><SearchIcon /></IconButton> </InputAdornment> ), }}}/>
                </Box>
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <MidBar />
                    <Box sx={{ flex: 1 }}>
                        <SideBarBottom {...props.childProps}></SideBarBottom>
                    </Box>
                </Box>
            </Box>
    )
}
export default SideBar

